import styled from 'styled-components';

export const Container = styled.div`
	width: ${(props) => (props.width ? props.width : '98%')};
	margin: ${(props) => (props.margin ? props.margin : ' 1rem 1.5rem')};
	padding: ${(props) => (props.padding ? props.padding : '1.5rem')};
	border-radius: 1.5rem;
	box-sizing: border-box !important;
	border: 1px solid rgba(222, 226, 230, 0.5);
	box-shadow: 0 1.6rem 3rem rgb(0 0 0 / 10%);
	background-color: ${(props) => props.bc && props.bc};
	-webkit-box-shadow: 0 1.6rem 3rem rgb(0 0 0 / 10%);
`;
